import React, { memo } from 'react';
import { BasicCircleCheckedIcon, BasicCircleXIcon, NavigationMenuInfoIcon, } from '@wildberries/ui-kit';
import { notificationStatus } from '../../../../../../constants';
export var NotificationsIcon = memo(function (_a) {
    var status = _a.status;
    switch (status) {
        case notificationStatus.success:
            return React.createElement(BasicCircleCheckedIcon, { colorType: "successTextColorColor" });
        case notificationStatus.error:
            return React.createElement(BasicCircleXIcon, { colorType: "inputErrorColor" });
        case notificationStatus.warning:
            return React.createElement(NavigationMenuInfoIcon, { colorType: "orangeColor" });
        default:
            return React.createElement(NavigationMenuInfoIcon, null);
    }
});
